/* eslint-disable @calm/react-intl/missing-formatted-message */
import React, { useState } from "react";
import { createRoot } from "react-dom/client";
import { WrappedIntlProvider } from "./react-components/wrapped-intl-provider";
import registerTelemetry from "./telemetry";
import "./utils/theme";
import { AuthContextProvider } from "./react-components/auth/AuthContext";
import { SignInModalContainer } from "./react-components/auth/SignInModalContainer";
import { PageContainer } from "./react-components/layout/PageContainer";
import "./react-components/styles/global.scss";
import "./assets/stylesheets/globals.scss";
import { Center } from "./react-components/layout/Center";
import { ThemeProvider } from "./react-components/styles/theme";
import { store } from "./utils/store-instance";
import FirebaseLogin from "./BoldlyXR/components/FirebaseLogin"; // Import FirebaseLogin component
import "./signin.scss";

registerTelemetry("/signin", "Hubs Sign In Page");

window.APP = { store };

function SignInRoot() {
  // Track whether TOTP verification has been completed
  const [isTotpVerified, setIsTotpVerified] = useState(false);

  // Callback function to update TOTP verification state
  const handleTotpSuccess = () => {
    setIsTotpVerified(true); // Update state when TOTP is successfully verified
  };

  return (
    <WrappedIntlProvider>
      <ThemeProvider store={store}>
        <AuthContextProvider store={store}>
          <PageContainer>
            <Center>
              {isTotpVerified ? (
                <SignInModalContainer /> // Show Hubs sign-in modal if TOTP is verified
              ) : (
                <FirebaseLogin onTotpSuccess={handleTotpSuccess} /> // Show FirebaseLogin otherwise
              )}
            </Center>
          </PageContainer>
        </AuthContextProvider>
      </ThemeProvider>
    </WrappedIntlProvider>
  );
}

const container = document.getElementById("ui-root");

const root = createRoot(container);
root.render(<SignInRoot />);
